import { seoFor } from "@/lib/i18n/keywordPools";
import { createFileRoute } from "@tanstack/react-router";
import About from "@/pages/About";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/about")({
  head: () => ({
    meta: [
      { title: "About Statlign — Our Sports Intelligence Engine" },
      { name: "keywords", content: seoFor({ topics: ["home"] }).meta },
      { name: "description", content: "How Statlign turns form, tactics, player data and historical patterns into transparent, explainable sports predictions." },
      { property: "og:title", content: "About Statlign — Our Sports Intelligence Engine" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "How Statlign turns form, tactics, player data and historical patterns into transparent, explainable sports predictions." },
      { name: "twitter:title", content: "About Statlign — Our Sports Intelligence Engine" },
      { name: "twitter:description", content: "How Statlign turns form, tactics, player data and historical patterns into transparent, explainable sports predictions." },
    ],
  }),
  component: () => (
    <MainLayout>
      <About />
    </MainLayout>
  ),
});
